/**
 * Resources Page Scripts
 *
 * Loaded on archive pages (blog, webinars, events listing)
 * Event-only scripts are in single-event/index.ts
 *
 * @package Interact_26
 */

import './styles/index.scss';

import { initFiltersToggle } from './scripts/filters-toggle';
import { initSmoothScroll } from './scripts/smooth-scroll';
import { initWebinarForm, initWebinarPlayButton } from './scripts/webinar-form';

const onDocumentReady = (callback: () => void): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

onDocumentReady(() => {
  initFiltersToggle();
  initWebinarForm();
  initWebinarPlayButton();
  initSmoothScroll();
});
